import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { FrontpageService } from '../../../../inputfileds/form_services/collegemanagement/frontpage.service';
import { AddmissionvisionComponent } from './addmissionvision/addmissionvision.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateDirective } from '../../../Utilites/Directives/translate.directive';
import { MatRippleModule } from '@angular/material/core';

interface VisionMission {
  uploadDate: string;
  content_type: 'missions' | 'visions';
  info: string;
  images: string;
  id: number;
  image_url: string;
  content: string;
}

@Component({
  selector: 'app-vision-mission',
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    TranslateDirective,
    MatRippleModule,
  ],
  templateUrl: './vision-mission.component.html',
  styleUrls: ['./vision-mission.component.scss'],
})
export class VisionMissionComponent implements OnInit {
  @Input() apiEndpoint!: string;
  @Input() heading!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;
  @Input() createApiEndpoint!: string;
  @Input() updateApiEndpoint!: string;

  displayedColumns: string[] = [
    'uploadDate',
    'content_type',
    'info',
    'images',
    'actions',
  ];

  VisionMissionData: VisionMission[] = [];

  imagePath = this.ApiService.environmentPath;

  constructor(
    private ApiService: ApiservicesService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.websiteId = this.route.snapshot?.queryParams['websiteId'];
    this.pageId = this.route.snapshot?.queryParams['pageId'];
    this.apiEndpoint = this.route.snapshot?.queryParams['endpoint'];
    this.getMissionVisionData();
  }

  openUploadDialog(
    contentType?: 'missions' | 'visions',
    rowData: VisionMission | null = null,
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = [
      'dialog-bottom-enter',
      'dialog-bottom-leave',
      'animate__animated',
    ];
    dialogConfig.minWidth = '60vw';
    dialogConfig.minHeight = '80vh';
    dialogConfig.maxHeight = '80vh';

    dialogConfig.data = {
      content_type: contentType,
      rowData,
      createApiEndpoint: this.apiEndpoint,
      websiteId: this.websiteId,
      pageId: this.pageId,
    };

    const dialogRef = this.dialog.open(AddmissionvisionComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getMissionVisionData();
      }
    });
  }

  EditopenUploadDialog(
    contentType: 'missions' | 'visions',
    rowData: VisionMission | null = null,
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = [
      'dialog-bottom-enter',
      'dialog-bottom-leave',
      'animate__animated',
    ];
    dialogConfig.minWidth = '60vw';
    dialogConfig.minHeight = '80vh';
    dialogConfig.maxHeight = '80vh';

    dialogConfig.data = {
      content_type: contentType,
      rowData,
      updateApiEndpoint: this.apiEndpoint,
    };

    const dialogRef = this.dialog.open(AddmissionvisionComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getMissionVisionData();
      }
    });
  }

  getMissionVisionData(): void {
    this.ApiService.getMissionVissionlist(
      this.websiteId,
      this.pageId,
      this.apiEndpoint,
    ).subscribe({
      next: (data: any) => {
        this.VisionMissionData = data.rows;
      },
      error: (error) => {
        console.error('Error fetching vision/mission data:', error);
        this.snackBar.open('Error loading data. Please try again.', 'Close', {
          duration: 5000,
        });
      },
    });
  }
  handleImageError (event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = '/assets/images/placeholder-mission-vision.jpg'; // ← change to your real fallback image
    img.alt = 'Image not available';
  }

  deleteItem(type: string, Id: number): void {
    const confirmDelete = confirm(
      `Are you sure you want to delete this ${type}?`,
    );
    if (confirmDelete) {
      this.ApiService.deleteMissionVision(Id).subscribe(
        (res: any) => {
          if (res.code === 200 && res.status === true) {
            this.getMissionVisionData();
          } else {
            console.error(
              'Error deleting banner:',
              res.message || 'Unknown error',
            );
          }
        },
        (error) => {
          console.error('API Error during delete:', error);
        },
      );
    }
  }
  goBack(): void {
    this.router.navigate([`/websites/WebcomponentList`], {
      queryParams: { websiteId: this.websiteId, pageId: this.pageId },
    });
  }
}
